import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
import { inject, onMounted } from "vue";
import {
  RouterName,
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  ShowErrorModal,
  SESSION_KEY_TERMS_RESULT,
  SESSION_KEY_LOGIN_ID,
  PROVIDE_KEY_SHOW_TOAST_MESSAGE,
  ShowToastMessage,
  SESSION_KEY_MASKING_USER_PHONE,
  SESSION_KEY_EZIOK_CERT_AUTH_VALUE_ENC,
} from "@/types";
import Page from "@/components/shared/Page.vue";
import { useRoute } from "vue-router";
import useGetSessionStorageItem from "@/use/useGetSessionStorageItem";
import { ITermsResult } from "@/repositories/user/userRepository.types";
import { useUserStore } from "@/stores/userStore";
import { handleAuthValue } from "@/utils/handleAuthValue";


const __default__ = {
  name: "AuthResult",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;
const showToastMessage = inject(
  PROVIDE_KEY_SHOW_TOAST_MESSAGE
) as ShowToastMessage;

const route = useRoute();
const userStore = useUserStore();
const context = route.query.context?.toString() ?? "";
const maskingUsername = route.query.maskingUsername?.toString() ?? "";
const maskingUserphone = route.query.maskingUserphone?.toString() ?? "";
const eziokCertAuthValueEnc =
  route.query.eziokCertAuthValueEnc?.toString() ?? "";
const errorCode = route.query.errorCode?.toString() ?? "";

const goToIdAuthPage = () => {
  router.replace({
    name: RouterName.IdAuthentication,
    query: { maskingUsername, maskingUserphone, eziokCertAuthValueEnc },
  });
};

const goToEditMyInfo = () => {
  handleAuthValue().setAuthValueToSessionStorage(
    maskingUserphone,
    eziokCertAuthValueEnc
  );
  window.history.go(-2);
};

const handleError = () => {
  if (!errorCode.length) return;
  showErrorModal(
    "본인인증 오류",
    "본인인증시 오류가 발생했습니다.",
    Number(errorCode)
  );
};

const requestUnlockAccount = async () => {
  const loginId = useGetSessionStorageItem<string>(SESSION_KEY_LOGIN_ID) ?? "";
  window.sessionStorage.removeItem(SESSION_KEY_LOGIN_ID);
  const unlockResult = await userStore.unlockAccount(
    loginId,
    eziokCertAuthValueEnc
  );

  if (unlockResult.isSuccess) {
    showToastMessage("계정 잠금이 해제되었습니다");
  } else {
    showErrorModal(
      "계정잠금 해제 오류",
      unlockResult.errorMessage,
      unlockResult.resultCode
    );
  }

  router.replace({ name: RouterName.Login });
};

const handleContext = () => {
  if (context === "unlock") {
    // 계정 잠금 해제 API 호출하기
    requestUnlockAccount();
  } else if (context === "signup") {
    const termsResult =
      useGetSessionStorageItem<ITermsResult[]>(SESSION_KEY_TERMS_RESULT) ?? [];
    userStore.setTermsResult(termsResult);
    // ID 인증 화면으로 이동
    goToIdAuthPage();
  } else if (context === "editmyinfo") {
    // 회원정보 수정 화면으로 이동
    goToEditMyInfo();
  }
};

onMounted(() => {
  if (errorCode.length) {
    handleError();
  } else {
    handleContext();
  }
});

const __returned__ = { showErrorModal, showToastMessage, route, userStore, context, maskingUsername, maskingUserphone, eziokCertAuthValueEnc, errorCode, goToIdAuthPage, goToEditMyInfo, handleError, requestUnlockAccount, handleContext, Page }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})